import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../stylesheets/style.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { CM_APIs } from "./CM_APIs";
import { Resource_APIs } from "../resourcerole/Resource_APIs";
import { UserConsumer } from "../../../UserContext";
import { Ticket_Variables } from "../variables/Ticket_Variables";
import { Config, Routes } from "../../../configurations/config";
import moment from "moment";
import { goBackFunction } from "../../../utils";
import FormStatus from "../../../components/FormStatus";
import { ticketStatus } from "../variables/ListingVariables";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { Redirect } from "react-router-dom";
import { AlertPopups } from "../../../components/AlertPopups";

const validation = Yup.object().shape({
	assigneePerson: Yup.string()
		.required("Select person")
		.typeError("Invalid value")
		.nullable(),
	cmComments: Yup.string()
		.max(500, "Max 500 characters allowed")
		.typeError("Invalid value"),
	datePicker: Yup.date()
		.required("Date is required")
		.typeError("Invalid input"),
});
let token,
	userId = null;
class CMTicketApproval extends Component {
	constructor(props) {
		super(props);
		this.state = {
			date: new Date().toDateString(),
			ticketDetails: {},
			departments: [],
			employees: [],
			assigneeDept: null,
			assigneePerson: null,
			selectUrgency: null,
			attachment: "",
			datePicker: "",
			persons: [],
			deptId: "",
			disableChange: false,
			deptComments: "",
			cmComments: "",
		};
		this.goBack = this.goBack.bind(this);
	}
	goBack = () => {
		goBackFunction(Routes.CMTicketListing, this.props.history);
	};
	handleReject = () => {
		AlertPopups.confirmBox
			.fire({
				text: `${AlertPopups.rejectTicketConfirm}`,
			})
			.then((result) => {
				let self = this;
				if (result.value) {
					let data = {
						updateBy: parseInt(userId),
						ticketId: parseInt(this.props.match.params.ticketId),
						departmentId: this.state.ticketDetails.departmentId,
						status: 3,
						isApproved: false,
						comment:
							this.state.cmComments.trim() !== ""
								? this.state.cmComments
								: null,
						assignTo: null,
						priority: this.state.ticketDetails.priority,
						expectedDate: moment(
							this.state.datePicker,
							"ddd MMM DD YYYY HH:mm:ss"
						).format("YYYY-MM-DDTHH:mm:00.000"),
						expectedTime: moment(
							this.state.datePicker,
							"ddd MMM DD YYYY HH:mm:ss"
						).format("YYYY-MM-DDTHH:mm:00.000"),
					};
					let headers = {
						Authorization: `Bearer ${token}`,
					};
					axios
						.put(`${CM_APIs.EditTicketByCM_API}`, data, {
							headers: headers,
						})
						.then(function (response) {
							if (response.status) {
								AlertPopups.InfoAlert.fire({
									text: `${AlertPopups.rejectTicketMsg}`,
								});
								goBackFunction(
									"/CountryManagerTicketListing",
									self.props.history
								);
							}
						})
						.catch((error) => {});
				}
			});
	};
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Resource_APIs.GetTicketDetail_API}${this.props.match.params.ticketId}`,
				{ headers: headers }
			)
			.then((res) => {
				this.setState({
					ticketDetails: res.data.ticket,
					deptComments: this.getRecentDeptComment(res.data.comments),
					cmComments: this.getRecentCMComment(res.data.comments),
					assigneePerson: {
						value: res.data.ticket.assignedTo,
						label: res.data.ticket.assignee,
					},
					selectItems: {
						value: res.data.ticket.itemId,
						label: res.data.ticket.itemName,
					},
					attachment: res.data.ticket.attachedFileName,
					Description: res.data.ticket.details,
					datePicker: new Date(res.data.ticket.expectedTime),
				});
				this.state.ticketDetails.priority === 0
					? this.setState({
							selectUrgency: { value: 0, label: "High " },
					  })
					: this.state.ticketDetails.priority === 1
					? this.setState({
							selectUrgency: { value: 1, label: "Medium " },
					  })
					: this.setState({
							selectUrgency: { value: 2, label: "Low " },
					  });
				this.state.ticketDetails.status === 3 ||
				this.state.ticketDetails.status === 2
					? this.setState({ disableChange: true })
					: this.setState({ disableChange: false });
				axios
					.get(
						`${Resource_APIs.GetDepartmentEmployees_API}${this.state.ticketDetails.departmentId}`,
						{ headers: headers }
					)
					.then((res) => {
						this.setState({ employees: res.data });
					});
			});
	}
	getRecentDeptComment = (comments) => {
		let deptComment = "";
		if (comments.length !== 0) {
			for (let element of comments) {
				if (!element.isCMComment) deptComment = element.ticketComment;
			}
			return deptComment;
		} else return "";
	};
	getRecentCMComment = (comments) => {
		let cmComment = "";
		if (comments.length !== 0) {
			for (let element of comments) {
				if (element.isCMComment) cmComment = element.ticketComment;
			}
			return cmComment;
		} else return "";
	};
	employeeListValues() {
		return this.state.employees.map((data) => ({
			label: data.employeeName,
			value: data.employeeId,
		}));
	}
	openDatepicker = () => this._calendar.setOpen(true);
	handleChange = (temp, displayCode, event) => {
		if (displayCode === 2 || displayCode === 3) {
			this.setState({
				[event.name]: temp,
			});
		} else if (displayCode === 4) {
			this.setState({
				datePicker: temp,
			});
		} else if (displayCode === 5) {
			this.setState({
				[temp.target.name]: temp.target.value,
			});
		}
	};
	handleSubmit = (values) => {
		AlertPopups.confirmBox
			.fire({
				text: `${AlertPopups.acceptTicketConfirm}`,
			})
			.then((result) => {
				if (result.value) {
					let self = this;
					let data = {
						updateBy: parseInt(userId),
						ticketId: parseInt(this.props.match.params.ticketId),
						assignTo: values.assigneePerson.value,
						departmentId: this.state.ticketDetails.departmentId,
						status: 1,
						isApproved: true,
						comment:
							values.cmComments.trim() !== ""
								? values.cmComments
								: null,
						priority: this.state.selectUrgency.value,
						expectedDate: moment(
							this.state.datePicker,
							"ddd MMM DD YYYY HH:mm:ss"
						).format("YYYY-MM-DDTHH:mm:00.000"),
						expectedTime: moment(
							this.state.datePicker,
							"ddd MMM DD YYYY HH:mm:ss"
						).format("YYYY-MM-DDTHH:mm:00.000"),
					};
					const headers = {
						Authorization: `Bearer ${token}`,
					};
					axios
						.put(`${CM_APIs.EditTicketByCM_API}`, data, {
							headers: headers,
						})
						.then(function (response) {
							if (response.status === 200) {
								AlertPopups.successAlert.fire({
									text: `${AlertPopups.acceptTicketMsg}`,
								});
								goBackFunction(
									Routes.CMTicketListing,
									self.props.history
								);
							}
						});
				}
			});
	};
	render() {
		const { ticketDetails } = this.state;
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					userId = userDetails.id;
					return userDetails.designation.toString() === "4" ? (
						<div className="container-fluid pl-3 pr-3">
							<FormStatus
								title="Approve or Reject Ticket"
								formStatus={ticketStatus(
									this.props.location.state.ticketStatus
								)}
								className="create-request d-flex align-items-center"
								onClick={() => this.goBack()}
								navigateBack={true}
							/>
							<Formik
								initialValues={this.state}
								enableReinitialize={true}
								onSubmit={(values) => this.handleSubmit(values)}
								validationSchema={validation}
								validateOnChange={true}
							>
								{({ values, errors, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders"
										>
											<Label sm={12}>
												Create ID #{" "}
												{
													this.props.match.params
														.ticketId
												}
											</Label>
										</FormGroup>
										<FormGroup
											row
											sm={12}
											className="bottom-spacing rowStyle1"
										>
											<Label sm={2}>Created By</Label>
											<Col sm={4} className="mt-2">
												<span className="dataSpan">
													{ticketDetails.creator}
												</span>
											</Col>
											<Label sm={2}>Ticket For</Label>
											<Col sm={4} className="mt-2">
												<span
													sm={4}
													className="dataSpan"
												>
													{ticketDetails.itemId !==
													null
														? ticketDetails.itemName
														: "Others"}
												</span>
											</Col>
										</FormGroup>
										<FormGroup
											row
											sm={12}
											className="bottom-spacing rowStyle2"
										>
											<Label sm={2}>Alternate item</Label>
											<Col sm={4} className="mt-2">
												<span className="dataSpan">
													{ticketDetails.alternateTicketItem ===
														null ||
													ticketDetails.alternateTicketItem ===
														""
														? "No alternate item"
														: ticketDetails.alternateTicketItem}
												</span>
											</Col>
											<Label sm={2}>Status</Label>
											<Col sm={4} className="mt-2">
												<span
													sm={3}
													className="dataSpan"
												>
													{ticketDetails.status === 0
														? "Pending"
														: ticketDetails.status ===
														  1
														? "InProgress"
														: ticketDetails.status ===
														  2
														? "Completed"
														: "Rejected"}
												</span>
											</Col>
										</FormGroup>
										<FormGroup
											row
											sm={12}
											className="bottom-spacing rowStyle1"
										>
											<Label sm={2}>Assigned to</Label>
											<Col sm={4} className="mt-2">
												<span className="dataSpan">
													{ticketDetails.department}
												</span>
											</Col>
											<Label htmlFor="Person" sm={2}>
												Assignee Person
											</Label>
											<Col sm={4}>
												<CustomReactSelect
													options={this.employeeListValues()}
													name="assigneePerson"
													id="assigneePerson"
													placeholder=""
													bsSize="sm"
													styles={
														Ticket_Variables.react_select_style
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															2,
															event
														)
													}
													value={
														this.state
															.assigneePerson
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label sm={2}>Priority</Label>
											<Col sm={4}>
												<CustomReactSelect
													options={
														Ticket_Variables.UrgencyValues
													}
													name="selectUrgency"
													id="selectUrgency"
													styles={
														Ticket_Variables.react_select_style
													}
													bsSize="sm"
													placeholder=""
													onChange={(value, event) =>
														this.handleChange(
															value,
															3,
															event
														)
													}
													value={
														this.state.selectUrgency
													}
													disabled={
														this.state.disableChange
													}
												/>
											</Col>
											<Label sm={2}>
												Due Date & Time
											</Label>
											<div
												style={{ fontWeight: "normal" }}
												className="col-sm-4"
											>
												<Col className="datepicker-wrapper pl-1 pr-2">
													<DatePicker
														showYearDropdown
														showMonthDropdown
														dateFormatCalendar=" " //for title
														name="datePicker"
														id="datePicker"
														bsSize="sm"
														selected={
															this.state
																.datePicker
														}
														onChange={(
															value,
															event
														) =>
															this.handleChange(
																value,
																4,
																event
															)
														}
														onChangeRaw={(e) => {
															e.preventDefault();
														}}
														className={`form-control datepicker form-control-sm ${
															errors.datePicker
																? "invalid"
																: ""
														}`}
														dateFormat="dd/MM/yyyy h:mm a"
														disabledKeyboardNavigation
														autoComplete="off"
														showTimeSelect
														minDate={new Date()}
														ref={(c) =>
															(this._calendar = c)
														}
														disabled={
															this.state
																.disableChange
														}
													/>

													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="calender-icon"
														color="keppel"
														onClick={
															this.openDatepicker
														}
													/>
												</Col>
											</div>
										</FormGroup>
										<FormGroup
											row
											sm={12}
											className="bottom-spacing rowStyle1"
											hidden={
												ticketDetails.attachedFileName ===
													null ||
												ticketDetails.attachedFileName ===
													"" ||
												ticketDetails.attachedFileName ===
													undefined
											}
										>
											<Label htmlFor="Attachment" sm={2}>
												Attachment
											</Label>
											<Col
												sm={10}
												className="mt-2 wordBreak"
											>
												{ticketDetails.attachedFileName !==
													null &&
												ticketDetails.attachedFileName !==
													"" &&
												ticketDetails.attachedFileName !==
													undefined ? (
													<span
														sm={9}
														className="dataSpan"
													>
														<a
															id="imageName"
															href={
																Config.server_url +
																ticketDetails.attachedFileName
															}
															target="_blank"
															rel="noopener noreferrer"
															style={{
																textDecoration:
																	"underline",
																color: "#43a3a5",
															}}
														>
															{ticketDetails.attachedFileName.slice(
																20,
																40
															)}
														</a>
													</span>
												) : (
													<span
														sm={9}
														className="dataSpan"
													>
														No attached file
													</span>
												)}
											</Col>
										</FormGroup>

										<FormGroup
											row
											className="bottom-spacing rowStyle2 "
										>
											<Label sm={2}>Description</Label>
											<Col sm={10} className="mt-2">
												<span
													sm={10}
													className="dataSpan wordBreak"
												>
													{ticketDetails.details}
												</span>
											</Col>
										</FormGroup>
										{this.state.deptComments.trim() !==
											"" && (
											<FormGroup
												row
												className="bottom-spacing rowStyle1"
											>
												<Label sm={2}>
													Department Comments
												</Label>
												{this.state.deptComments
													.length !== "" && (
													<Col
														sm={10}
														className="mt-2"
													>
														<span
															sm={10}
															className="dataSpan wordBreak"
														>
															{
																this.state
																	.deptComments
															}
														</span>
													</Col>
												)}
											</FormGroup>
										)}
										<FormGroup
											row
											className="rowStyle2 bottom-spacing lastRow"
										>
											<Label sm={2}>Comments</Label>
											<Col sm={10}>
												<Input
													type="textarea"
													className={`h-auto ${
														errors.cmComments
															? "invalid"
															: ""
													}`}
													name="cmComments"
													id="cmComments"
													disabled={
														this.state.disableChange
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															5,
															event
														)
													}
													value={
														this.state.cmComments
													}
													maxLength="500"
												/>
											</Col>
										</FormGroup>

										<div className="btns mt-4">
											<Button
												type="button"
												id="rejectBtn"
												className="delete-btn leftBtn"
												onClick={() =>
													this.handleReject()
												}
												hidden={
													this.state.disableChange
												}
											>
												Reject
											</Button>
											<Button
												id="row0"
												className="approve-btn"
												type="Submit"
												hidden={
													this.state.disableChange
												}
											>
												Accept
											</Button>
										</div>
									</form>
								)}
							</Formik>
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
export default CMTicketApproval;
